export const PAGE_PADDING_SMALL = '16px';
export const PAGE_PADDING_MEDIUM = '64px';
export const PAGE_PADDING_LARGE = '108px';
export const COLUMNS_GAP_MEDIUM = '32px';
export const IMAGE_MAX_WIDTH_1 = '561px';
